import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import {
    JiraOverlayTemplate,
    LayoutVersion
} from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";
import { experiments, useExperiment } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { useLocation } from "@/utils/location-provider";
import { getWacIntegrationUrl } from "@/utils/urls";

import { InputSubmitButton, GetStartedHeading } from "../../../components";

export const LoggedOutJiraFree = () => {
    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    const version = modalVisualUpdates ? LayoutVersion.V3 : LayoutVersion.V1;

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const editionIntent = searchParams.get("editionIntent");

    const jiraPlusPage = useLocalizedHref(
        `/software/jira/free${
            editionIntent ? `?editionIntent=${editionIntent}` : ""
        }`
    );

    let continueUrl: string | undefined = undefined;

    const jiraPlusExperiment = useExperiment(experiments.twcg1444JiraPlusOptIn);
    if (jiraPlusExperiment.type === "enrolled") {
        jiraPlusExperiment.fireExposure();
        if (jiraPlusExperiment.value) {
            continueUrl = `${getWacIntegrationUrl()}${jiraPlusPage}`;
        }
    }

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm" version={version}>
                <GetStartedHeading productName="Jira" />
                <p
                    css={[
                        subHeaderCss,
                        !modalVisualUpdates && subHeaderBlackCss
                    ]}
                >
                    <FormattedMessage
                        id="signupForm.accountCreation.subHeaderText"
                        defaultMessage="It’s free for up to 10 users - no credit card needed."
                    />
                </p>
                <FeatureExposed
                    experimentKey="jfind-1185-signup-button-update"
                    group="Test"
                >
                    <AccountCreation
                        continueUrl={continueUrl}
                        Input={<InputSubmitButton />}
                        Submit={null}
                    />
                </FeatureExposed>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const subHeaderCss = css({
    margin: "0 0 24px",
    textAlign: "center"
});

const subHeaderBlackCss = css({
    color: wacToken("color.primary.black")
});
